import * as THREE from "three";

const RGBtoHex = (red, green, blue) => {
    return "#" + colorToHex(red) + colorToHex(green) + colorToHex(blue);
}
const hexToRGB = (hex) => {
    const red = parseInt(hex.substring(1, 3), 16);
    const green = parseInt(hex.substring(3, 5), 16);
    const blue = parseInt(hex.substring(5, 7), 16);
    return { red, green, blue };
}

function setOnTheMiddle33(group){
    const box = new THREE.Box3().setFromObject(group);
    const size = box?.getSize(new THREE.Vector3());
    const yOffset = size.y / -2;
    const xOffset = size.x / -2;

    // Offset all of group's elements, to center them
    group.children.forEach((item) => {
        item.position.x = xOffset;
        item.position.y = yOffset;
    });
}
function setOnTheMiddledd(group){
    if (!group) return;

    const box = new THREE.Box3().setFromObject(group);
    const center = box.getCenter(new THREE.Vector3());
    console.log("cenetttte",center);
    group.position.sub(center);
}
function setOnTheMiddle(group){
    if (!group) return;

    // Asegurar matrices actualizadas
    group.updateMatrixWorld(true);

    // Bounding box en world-space (asume group.position = (0,0,0) en este momento)
    const box = new THREE.Box3().setFromObject(group);
    const worldCenter = box.getCenter(new THREE.Vector3());
    const scale = group.scale;

    // Convertir el centro world-space a offset en local-space de cada hijo.
    // worldCenter = scale * localOffset  =>  localOffset = worldCenter / scale
    // Desplazamos los hijos para que el centro visual coincida con el origen local (0,0,0).
    // Así la rotación del grupo ocurre alrededor del centro visual del logotipo.
    // El eje Z no se centra porque la profundidad de extrusión cambia dinámicamente.
    const localOffsetX = worldCenter.x / scale.x;
    const localOffsetY = worldCenter.y / scale.y;

    group.children.forEach((child) => {
        child.position.x -= localOffsetX;
        child.position.y -= localOffsetY;
    });

    // El grupo permanece en el origen para que la rotación sea alrededor del centro
    group.position.set(0, 0, 0);
}


const colorToHex = (color) => {
    const hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
}


const getContrastingColor = (color) => {
    // Remove the '#' character if it exists
    const hex = color.replace("#", "");

    // Convert the hex string to RGB values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate the brightness of the color
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Return black or white depending on the brightness
    return brightness > 128 ? "black" : "white";
};





const fitCameraToCenteredObject = (
    camera,
    object
) => {
    const boundingBox = new THREE.Box3();

    boundingBox.setFromObject(object);

    const center = boundingBox.getCenter(new THREE.Vector3());
    const size = boundingBox.getSize(new THREE.Vector3());
    const maxSize = Math.max(size.x, size.y, size.z);
    let newPositionCamera = new THREE.Vector3(maxSize, maxSize, maxSize);
    camera.zoom = 1;
    camera.left = -(2 * maxSize);
    camera.bottom = -(2 * maxSize);
    camera.top = 2 * maxSize;
    camera.right = 2 * maxSize;
    camera.near = -maxSize * 4;
    camera.far = maxSize * 4;
    // camera;
    camera.position.set(
        newPositionCamera.x,
        newPositionCamera.y,
        newPositionCamera.z
    );
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
};


export {RGBtoHex, setOnTheMiddle, getContrastingColor, hexToRGB, fitCameraToCenteredObject}